const {
  ValidatorTypes,
} = require('../constants');

const {
  dob,
  dobRequired,
  isAdult,
} = require('./date');

const {
  email,
  emailRequired,
} = require('./email');

const {
  abn,
  acn,
  abnRequired,
  acnRequired
} = require('./abn');

const {
  name,
  nameRequired,
  fullName,
  fullNameRequired,
  alphanumericName,
  alphanumericNameRequired,
  alphanumericFullname,
  alphanumericFullnameRequired,
} = require('./name');

const {
  phoneNumber,
  phoneNumberRequired,
  phoneNoSameValues,
} = require('./phone');

const {
  salesVxSplit,
  salesVxDisbursementPurpose,
  salesVxPurpose,
  salesVxDeposit,
  salesVxReceipt,
  salesVxAttachMember,
  salesVxSecurity,
  salesVxFeeConfig,
} = require('./sales-vx-core');

const {
  salesVxAccountingFee,
  salesAccountingFeeConfiguration,
} = require('./sales-vx-accounting');

const {
  salesVxClientAddress,
} = require('./sales-vx-client');

const {
  salesVxCollateralMotorVehicle,
  salesVxCollateralInvoice,
} = require('./sales-vx-collateral');

const {
  salesVxRepymentCalculator,
} = require('./sales-vx');

const {
  clientBrandStore,
  brandText,
  brandTextRequired,
} = require('./client-brandstore');

const {
  invoiceNumber,
} = require('./invoice-number');

const {
  bsb,
} = require('./bsb');

const {
  bankAccountName,
  bankAccountNumber,
} = require("./client-bank-account");

const {
  accountTransaction,
  narrationDescription,
} = require('./account-transaction');

const {
  feeConfiguration,
} = require('./fee-configuration');

const {
  paymentRequest,
  paymentSubmission,
} = require('./payment');

const {
  employment,
} = require('./employment');

const {
  unitNumber,
  streetNumber,
  streetName,
  streetType,
  suburb,
  nonAuSuburb,
  state,
  country,
  address,
  addressRequired,
  postcode,
  postcodeRequired,
  nonAuPostcode,
  nonAuPostcodeRequired,
  monthsAtResidence,
  yearsAtResidence,
  monthsAtResidenceRequired,
  yearsAtResidenceRequired,
} = require('./address');

const {
  driversLicenceCardNumber,
  driversLicenceNumber,
} = require('./drivers-licence');

const {
  boolean,
  booleanRequired,
  requiredFalse,
  requiredTrue,
} = require('./boolean');

const { uniqueItemInArray } = require('./array');
const {
  loanAmount,
} = require('./product');

/**
 * Validators are shortcuts to validators using custom contexts or chained validators
 * @namespace validators
 */
module.exports = {
  abn,
  acn,
  abnRequired,
  acnRequired,
  dob,
  dobRequired,
  isAdult,
  email,
  emailRequired,
  name,
  nameRequired,
  fullName,
  fullNameRequired,
  alphanumericName,
  alphanumericNameRequired,
  alphanumericFullname,
  alphanumericFullnameRequired,
  phoneNumber,
  unitNumber,
  streetNumber,
  streetName,
  streetType,
  suburb,
  nonAuSuburb,
  state,
  country,
  phoneNumberRequired,
  phoneNoSameValues,
  [ValidatorTypes.SALES_VX_SPLIT]: salesVxSplit,
  [ValidatorTypes.SALES_VX_DISBURSEMENT_PURPOSE]: salesVxDisbursementPurpose,
  [ValidatorTypes.SALES_VX_DEPOSIT]: salesVxDeposit,
  [ValidatorTypes.SALES_VX_PURPOSE]: salesVxPurpose,
  [ValidatorTypes.SALES_VX_RECEIPT]: salesVxReceipt,
  [ValidatorTypes.SALES_VX_ATTACH_MEMBER]: salesVxAttachMember,
  [ValidatorTypes.SALES_VX_ACCOUNTING_FEE]: salesVxAccountingFee,
  [ValidatorTypes.SALES_VX_SECURITY]: salesVxSecurity,
  [ValidatorTypes.SALES_CLIENT_ADDRESS]: salesVxClientAddress,
  [ValidatorTypes.SALES_VX_COLLATERAL_MOTOR_VEHICLE]: salesVxCollateralMotorVehicle,
  [ValidatorTypes.SALES_VX_COLLATERAL_INVOICE]: salesVxCollateralInvoice,
  [ValidatorTypes.SALES_VX_FEE_CONFIG_LOOKUP]: salesVxFeeConfig,
  [ValidatorTypes.PAYMENT_REQUEST]: paymentRequest,
  [ValidatorTypes.PAYMENT_SUBMISSION]: paymentSubmission,
  address,
  addressRequired,
  postcode,
  postcodeRequired,
  nonAuPostcode,
  nonAuPostcodeRequired,
  monthsAtResidence,
  yearsAtResidence,
  monthsAtResidenceRequired,
  yearsAtResidenceRequired,
  driversLicenceCardNumber,
  'drivers-licence-number-act': driversLicenceNumber.AustralianCapitalTerritory,
  'drivers-licence-number-nsw': driversLicenceNumber.NewSouthWales,
  'drivers-licence-number-nt': driversLicenceNumber.NorthernTerritory,
  'drivers-licence-number-wa': driversLicenceNumber.WesternAustralia,
  'drivers-licence-number-sa': driversLicenceNumber.SouthAustralia,
  'drivers-licence-number-tas': driversLicenceNumber.Tasmania,
  'drivers-licence-number-qld': driversLicenceNumber.Queensland,
  'drivers-licence-number-vic': driversLicenceNumber.Victoria,
  boolean,
  booleanRequired,
  requiredFalse,
  requiredTrue,
  uniqueItemInArray,
  [ValidatorTypes.SALES_VX_REPAYMENT_CALCULATOR]: salesVxRepymentCalculator,
  [ValidatorTypes.CLIENT_BRANDSTORE]: clientBrandStore,
  brandText,
  brandTextRequired,
  invoiceNumber,
  bsb,
  [ValidatorTypes.ACCOUNT_TRANSACTION]: accountTransaction,
  narrationDescription,
  [ValidatorTypes.PRODUCT_LOAN_AMOUNT]: loanAmount,
  [ValidatorTypes.FEE_CONFIGURATION]: feeConfiguration,
  [ValidatorTypes.SALES_VX_ACCOUNTING_FEE_CONFIG]: salesAccountingFeeConfiguration,
  bankAccountName,
  bankAccountNumber,
  employment,
};
